import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
  Accordion,
  Col,
  KeyValue,
  NoValue,
  Row,
} from '@folio/stripes/components';
import { ViewMetaData } from '@folio/stripes/smart-components';

const GeneralInformation = ({
  team: {
    name,
    description,
    metadata,
  }
}) => {
  return (
    <Accordion
      id="general"
      label={<FormattedMessage id="ui-task-list.title.accordion.generalInformation" />}
    >
      {metadata && (
        <Row>
          <Col sm={12}>
            <ViewMetaData
              id="metadata"
              metadata={metadata}
            />
          </Col>
        </Row>
      )}
      <Row>
        <Col sm={12}>
          <KeyValue
            data-test-team-details-name
            label={<FormattedMessage id="ui-task-list.team.field.name" />}
            value={name}
          />
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <KeyValue
            data-test-team-details-description
            label={<FormattedMessage id="ui-task-list.team.field.description" />}
            value={description || <NoValue />}
          />
        </Col>
      </Row>
    </Accordion>
  );
};

GeneralInformation.propTypes = {
  team: PropTypes.shape({
    description: PropTypes.string,
    metadata: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
  })
};

GeneralInformation.defaultProps = {
  team: PropTypes.shape({
    description: '',
  })
};

export default GeneralInformation;
